import React from "react"
import "./AdminDropdown.css"
import { Link } from "react-router-dom"
import {
  SettingsIcon,
  LogOutIcon,
  UserProfileIcon,
  GiftIcon
} from "../../common/Icons"
import { ROUTES } from "../../common/utils"

class AdminDropdown extends React.Component {
  constructor(props) {
    super(props)
    this.setWrapperRef = this.setWrapperRef.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside)
  }

  setWrapperRef(node) {
    this.wrapperRef = node
  }

  handleClickOutside(event) {
    const { onDropClick } = this.props
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      onDropClick("off")
    }
  }

  render() {
    const { onLinkSelect } = this.props
    return (
      <div ref={this.setWrapperRef}>
        <div className="dropdown-pointer" />
        <div className="dropdown-box">
          <div className="options">
            <span
              className="userProfile"
              onClick={() => onLinkSelect(ROUTES.USER_PROFILE)}
            >
              <UserProfileIcon />
              <span className="link">Your Profile</span>
            </span>
            <hr />
            <span
              className="grid"
              onClick={() => onLinkSelect(ROUTES.REFERRAL)}
            >
              <GiftIcon />
              <span className="link">Refer a friend</span>
            </span>
            <span
              className="grid"
              onClick={() => onLinkSelect(ROUTES.SETTINGS)}
            >
              <SettingsIcon />
              <span className="link">Settings</span>
            </span>
            <span className="grid" onClick={() => onLinkSelect(ROUTES.LOGOUT)}>
              <LogOutIcon />
              <Link to={ROUTES.LOGOUT}>Log Out</Link>
            </span>
          </div>
        </div>
      </div>
    )
  }
}

export default AdminDropdown
